export enum RegisterIntent {
  Register = 0,
  Subscribe = 1
}
